<template>
  <v-card class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4" :outlined="outlined" :flat="flat">
    <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-center tw-px-2 md:tw-px-8">
      <div class="tw-flex md:tw-block tw-px-2 tw-justify-between tw-w-full md:tw-w-auto tw-mb-3 md:tw-mb-0">
        <h2 class="c-navy-text tw-font-bold">INPATIENT</h2>
        <span><v-icon size="15" color="primary">mdi-check-circle</v-icon> <small class="c-navy-text ">Main Cover</small></span>
      </div>
      <div class="tw-w-full md:tw-w-3/6 tw-px-0 md:tw-px-5 md:tw-border-r-2 tw-border-gray-300">
        <p class="tw-text-sm c-gray-text">This covers the insured whilst admitted as an inpatient in a hospital</p>
      </div>
      <div>
        <h2 class="c-navy-text tw-font-bold tw-text-xl" >LIMIT: Ksh {{inpatient_limit | formatNum}} per family</h2>
      </div>
    </div>
    <div class="tw-mt-4 tw-flex tw-flex-wrap tw-justify-between tw-px-0 md:tw-px-8">
      <v-btn v-for="r in limits" :key="r.value" class="tw-mt-4" :color="inpatient_limit === r.value ? 'primary' : 'default'" @click="addLimit(r.value)"><span :class="inpatient_limit === r.value ? 'tw-font-bold' : 'c-blue-text tw-font-bold'">{{ r.label }}</span></v-btn>
    </div>
  </v-card>
</template>

<script>
import helpers from '@/utils/helpers';

export default {
  name: 'Inpatient',
  props: {
    flat: {
      default: true,
    },
    outlined: {
      default: true,
    },
  },
  data(vm) {
    return {
      inpatient_limit: vm.$store.getters['rfq/getHealthQuote'].inpatient_limit || 500000,
      limits: [
        {
          label: 'KSH 500,000',
          value: 500000,
        },
        {
          label: 'KSH 1,000,000',
          value: 1000000,
        },
        {
          label: 'KSH 2,000,000',
          value: 2000000,
        },
        {
          label: 'KSH 3,000,000',
          value: 3000000,
        }, {
          label: 'KSH 5,000,000',
          value: 5000000,
        },
      ],
    };
  },
  mounted() {
    if (this.inpatient_limit === 500000) this.$store.commit('rfq/setHealthQuotation', { inpatient_limit: 500000 });
  },
  methods: {
    addLimit(val) {
      this.inpatient_limit = val;
      this.$store.commit('rfq/setHealthQuotation', { inpatient_limit: val });
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
